import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { latLonToVector3 } from "../lib/seismic";

export function FaultLines({ radius = 2.008 }) {
  const [geometry, setGeometry] = useState(null);
  const matRef = useRef();

  useEffect(() => {
    let alive = true;
    fetch("/data/plate_boundaries.json")
      .then((r) => r.json())
      .then((geo) => {
        if (!alive) return;
        const positions = [];
        for (const feature of geo.features || []) {
          const g = feature.geometry;
          if (!g) continue;
          const lines = g.type === "MultiLineString" ? g.coordinates : [g.coordinates];
          for (const line of lines) {
            for (let i = 0; i < line.length - 1; i++) {
              const a = latLonToVector3(line[i][1], line[i][0], radius);
              const b = latLonToVector3(line[i + 1][1], line[i + 1][0], radius);
              positions.push(a.x, a.y, a.z, b.x, b.y, b.z);
            }
          }
        }
        const geom = new THREE.BufferGeometry();
        geom.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
        setGeometry(geom);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [radius]);

  useFrame((state) => {
    if (matRef.current) {
      matRef.current.opacity = 0.95 + Math.sin(state.clock.elapsedTime * 1.8) * 0.25;
    }
  });

  if (!geometry) return null;

  return (
    <lineSegments geometry={geometry}>
      <lineBasicMaterial
        ref={matRef}
        color="#ffd21a"
        transparent
        opacity={0.95}
        blending={THREE.AdditiveBlending}
        depthWrite={false}
        toneMapped={false}
      />
    </lineSegments>
  );
}
